"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.useBreakpoint = useBreakpoint;
exports.BreakpointContext = exports.BreakpointProvider = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

const defaultValue = {};
const BreakpointContext = /*#__PURE__*/(0, _react.createContext)(defaultValue);
exports.BreakpointContext = BreakpointContext;

const BreakpointProvider = ({
  children,
  queries
}) => {
  const [queryMatch, setQueryMatch] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    const mediaQueryLists = {};
    const keys = Object.keys(queries);
    let isAttached = false;

    const handleQueryListener = () => {
      const updatedMatches = keys.reduce((acc, media) => {
        acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
        return acc;
      }, {});
      setQueryMatch(updatedMatches);
    };

    if (window && window.matchMedia) {
      const matches = {};
      keys.forEach(media => {
        if (typeof queries[media] === 'string') {
          mediaQueryLists[media] = window.matchMedia(queries[media]);
          matches[media] = mediaQueryLists[media].matches;
        } else {
          matches[media] = false;
        }
      });
      setQueryMatch(matches);
      isAttached = true;
      keys.forEach(media => {
        if (typeof queries[media] === 'string') {
          mediaQueryLists[media].addListener(handleQueryListener);
        }
      });
    }

    return () => {
      if (isAttached) {
        keys.forEach(media => {
          if (typeof queries[media] === 'string') {
            mediaQueryLists[media].removeListener(handleQueryListener);
          }
        });
      }
    };
  }, [queries]);
  return /*#__PURE__*/_react.default.createElement(BreakpointContext.Provider, {
    value: queryMatch
  }, children);
};

exports.BreakpointProvider = BreakpointProvider;
BreakpointProvider.propTypes = {
  children: _propTypes.default.element.isRequired,
  queries: _propTypes.default.object.isRequired
};

function useBreakpoint() {
  const context = (0, _react.useContext)(BreakpointContext);

  if (context === defaultValue) {
    throw new Error('useBreakpoint must be used within BreakpointProvider');
  }

  return context;
}